import Navigation from './components/Navigation';
import VideoLightbox from './components/VideoLightbox';

/**
 * Controller class.
 *
 * Standardizes how we hook into event listeners and create components.
 */
class Controller {
	constructor() {
		this.init();

		window.addEventListener('resize', this.resized);
		window.addEventListener('load', this.loaded);
	}

	init() {
		Navigation.init();
		VideoLightbox.init();
	}

	// eslint-disable-next-line @typescript-eslint/no-empty-function
	resized() {}

	// eslint-disable-next-line @typescript-eslint/no-empty-function
	loaded() {}
}

// Run controller.
new Controller();
